import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form';

import TagSelector from '../common/TagSelector';
import FieldError from './FieldError';

export default function TagField({
    label,
    info,
    name,
    className,
    dataList,
}) {
    const { register, errors, setValue, watch } = useFormContext();
    const tagNameList = watch(name);

    useEffect(() => {
        register({ name: `${name}`, type: 'custom' });
    }, [register, name])

    const handleTagChange = tags => {
        setValue(name, tags);
    }

    const styles = {
        wrapper: {
            marginBottom: "1.5rem",
        },
        label: {
            display: "block",
            fontWeight: "bold",
            marginBottom: "0.5rem",
            color: "#26344a",
            fontSize: "1.8rem",
        },
        help: {
            color: "#23d160",
            fontSize: "1.1rem",
            marginTop: "0.25rem",
        }
    };

    return (
        <div style={styles.wrapper} className={className}>
            <label style={styles.label}>{label}</label>
            <TagSelector dataList={dataList} onChange={handleTagChange} values={tagNameList} />
            {info && <p style={styles.help}>{info}</p>}
            <FieldError errors={errors[name]} />
        </div>
    )
}
